/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { notificationSnackbarDurationSelector } from '../ngrx/error.selectors';
import { AppState } from '../types';

@Injectable({ providedIn: 'root' })
export class GmcNotificationService {
  private snackbar = inject(MatSnackBar);
  private store = inject(Store<AppState>);

  public notify(message: string): void {
    const duration = this.store.selectSignal(notificationSnackbarDurationSelector)();
    this.snackbar.open(message, '', {
      duration,
      panelClass: 'snackbar-notification',
    });
  }
}
